<template>
  <v-sheet height="100%" color="bg1" width="100%">
    <v-dialog v-model="isUploadingPointCloud" persistent max-width="400">
      <v-card>
        <v-card-title class="h6 py-2">Uploading Point Clouds</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-2 py-2">
          <div class="d-flex align-center">{{ progress }}/{{ maxProgress }} Files uploading</div>
          <div v-if="currentFile">
            File name: <b>{{ currentFile.name }}</b> ({{
              (currentFile.size / 1024 / 1024).toFixed(2)
            }}
            MB)
          </div>
          <div class="d-flex flex-row align-center" style="gap: 4px">
            <v-progress-linear :value="fileProgress" color="primary" height="10" rounded>
            </v-progress-linear>
            {{ fileProgress }}%
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" text class="w-100" @click="cancelUpload">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isDeleting" persistent max-width="400">
      <v-card>
        <v-card-title class="h6 py-2">Deleting Point Clouds</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-2 py-2">
          <div class="d-flex align-center mb-2">Deleting is in progress</div>
          <v-progress-linear indeterminate color="error" height="10" rounded></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-sheet height="100%" class="rounded-tl-lg overflow-hidden pa-4 d-flex flex-column">
      <div
        class="pa-2 d-flex align-center justify-space-between"
        style="gap: 8px"
        :class="{
          'flex-wrap': $vuetify.breakpoint.xs,
        }">
        <div class="d-flex align-center flex-wrap">
          <h3 class="me-3">Manage Scans</h3>
          <v-sheet :width="$vuetify.breakpoint.xs ? '100%' : 250">
            <v-text-field
              hide-details
              outlined
              dense
              v-model="searchTxt"
              class="search-bar"
              placeholder="Search..."
              clearable
              prepend-inner-icon="mdi-magnify"></v-text-field>
          </v-sheet>
          
          <v-chip 
            v-if="Object.keys(storageLimits).length > 0"
            class="ml-3 storage-indicator" 
            :color="storageStatusColor"
            outlined
          >
            <v-icon left small>{{ storageStatusIcon }}</v-icon>
            Upload Count: {{ storageLimits.uploadUsed }} / {{ storageLimits.uploadLimit }}
          </v-chip>
        </div>

        <div v-has="permissions.AdminPointClouds.Upload" class="align-center">
          <input
            type="file"
            webkitdirectory
            multiple
            style="display: none"
            id="browsePointCloudFile"
            @change="onPointCloudFileChanged($event)" />
          <!-- <progress
            style="width: 50%; height: 20px"
            v-if="isUploadingPointCloud"
            min="0"
            :max="maxProgress"
            step="1"
            :value="progress"></progress>
          <div v-if="isUploadingPointCloud">
            {{ progress }}/{{ maxProgress }} Files {{ isDeleting ? 'Deleted' : 'Uploaded' }}
          </div> -->

          <div class="d-flex justify-center" style="gap: 0.75rem">
            <v-scroll-x-transition>
              <v-btn color="error" v-if="selected_items.length > 0" @click="deleteSelectedItems()">
                <v-icon class="me-2">mdi-delete</v-icon> Delete Selected Clouds</v-btn
              >
            </v-scroll-x-transition>

            
            <!-- Dropdown Menu for Point Cloud Options -->
            <v-menu
              v-model="addPointCloudMenu"
              :close-on-content-click="false"
              offset-y
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>mdi-plus</v-icon>
                  Add Point Cloud
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              
              <v-card>
                <v-list>
                  <v-list-item @click="AddPointCloudFolder()">
                    <v-list-item-icon>
                      <v-icon>mdi-folder-plus</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Add Synology Folder</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  
                  <v-list-item @click="AddPointCloudURL()">
                    <v-list-item-icon>
                      <v-icon>mdi-link-variant</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Add URL</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  
                  <v-tooltip bottom :color="tooltipColor" :disabled="!isUploadDisabled">
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item 
                        @click="clickOnUploadPointCloud()" 
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-list-item-icon>
                          <v-icon>mdi-upload</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Upload</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                        
                          <v-icon v-if="isUploadDisabled" :color="tooltipColor">{{ tooltipIcon }}</v-icon>
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                    <span>
                      <v-icon small :color="tooltipIconColor" class="mr-1">{{ tooltipIcon }}</v-icon>
                      {{ tooltipMessage }}
                    </span>
                  </v-tooltip>
                </v-list>
              </v-card>
            </v-menu>

            <v-btn v-if="$has(permissions.AdminPointClouds.Converter)" link color="primary" @click="downloadPointCloudUtility()">
              <v-icon class="me-2">mdi-download</v-icon> Point Cloud Utility</v-btn>
          </div>
        </div>
      </div>
      <v-data-table
        class="elevation-0 pa-2 rounded-0 d-flex flex-column table-sticky custom-table flex-grow-1"
        v-model="selected_items"
        :headers="pointCloudsHeaders"
        :search="searchTxt"
        :items="pointclouds"
        show-select>
        <template v-slot:[`item.name`]="{ item }">
          <b style="padding-left: 5px; flex-grow: 1">{{ item.name }}</b
          ><br />
        </template>

        <template v-slot:[`item.createDate`]="{ item }">
          <div class="d-flex justify-space-between align-center">
            <div v-if="item.createDate">
              {{ $formatDate(item.createDate) }}
            </div>
            <v-chip v-if="item.isOnlyURL" class="ma-2" color="primary" small>
              <v-icon left small>mdi-check </v-icon> Linked
            </v-chip>
            <v-chip
              v-else-if="!item.isOnlyURL && item.isUploaded"
              class="ma-2"
              color="primary"
              small>
              <v-icon left small>mdi-check </v-icon> Uploaded
            </v-chip>
            <v-chip
              v-else-if="!item.isOnlyURL && !item.isUploaded"
              class="ma-2"
              color="warning"
              small>
              <v-icon left small>mdi-close </v-icon> Uncompleted
            </v-chip>
            <!-- <div class="linked-pointcloud">Linked</div> -->
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-menu dense offset-x right>
            <template v-slot:activator="{ attrs, on }">
              <v-btn icon elevation="0" v-bind="attrs" v-on="on">
                <v-icon size="16px">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list class="more-options-menu" dense>
              <v-list-item
                v-has="permissions.AdminPointClouds.Upload"
                @click.stop="editPointCloudUrl(item)"
                dense>
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small color="success">mdi-pencil-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Update</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                @click.stop="onPointCloudDeleting(item)"
                dense
                v-has="permissions.AdminPointClouds.Delete">
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small color="error">mdi-delete</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:no-data>
          <div class="text-center d-flex flex-column">
            <img width="300" src="/img/notFound.svg" class="py-5 my-8" style="opacity: 0.54" />
            <p class="font-weight-medium">No Data Available!</p>
          </div>
        </template>

        <template v-slot:loading>
          <div class="text-center d-flex flex-column">
            <img width="300" src="/img/loading.svg" class="py-5 my-8" style="opacity: 0.54" />
            <p class="font-weight-medium">Loading Point Clouds...</p>
          </div>
        </template>
      </v-data-table>
    </v-sheet>
  </v-sheet>
</template>

<script>
  /* eslint-disable no-unreachable */
  import { postDataAsync } from '@Utils/mongoUtils';
  import { toggleExpandComponent } from '@/scripts/js/forgeviewer';
  import { PointCloudModelInfo } from '@/scripts/js/forgeModels';
  // import SelectionInfo from '@/components/common/selectionInfo.vue';
  import permissions from '@Share/config/permissions';
  import pointCloudsHeaders from '../config/pointClouds.headers';
  import { $formatDate } from '@Utils';
  import { mapGetters } from 'vuex';
  import pointcloudsService from '../services/pointclouds.service';
  import pointCloudUtilityService from '../services/pointcloudutility.service';
  import httpService from '@/utils/httpService';
  import { downloadURI } from '@/scripts/js/forgeService';
  import { $has } from '@/utils';
  import storageService from '../services/blobstorage.service';
  import { log, warn, error } from '@/utils/debugLogger';
  export default {
    name: 'AdminPointClouds',
    components: {
      // SelectionInfo,
    },
    props: ['pointclouds'],
    data() {
      return {
        permissions,
        isExpanded: false,
        isUploadingPointCloud: false,
        progress: 0,
        fileProgress: 0,
        currentFile: null,
        abortController: null,
        maxProgress: 100,
        isDeleting: false,
       
        selected_items: [],
        pointCloudsHeaders,
        searchTxt: '',
     
        addPointCloudMenu: false,
    
        storageLimits: {},
      };
    },
    mounted() {
      storageService.getLimitsByFacility(this.$route.params.id).then((res) => {
        this.storageLimits = res.data;
      });
    },
    methods: {
      $has,
      $formatDate,
     
      onClearSelection() {
        this.pointclouds.forEach((o) => (o.isSelected = false));
        // this.updateSelectedItems();
      },
      deleteSelectedItems() {
        this.$dialog.error({
          text: 'Are you sure you want to delete selected point cloud/s?',
          title: 'Delete Point Cloud',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                let ids = this.selected_items.map((o) => o.id);
                this.deletePointClouds(ids).then(() => {
                  this.selected_items = [];
                });
              },
            },
          },
        });
      },
      onPointCloudFileChanged(event) {
        if (event.target.files.length == 0) return;

        this.$store.dispatch({
          type: 'prompt_Forge',
          title: 'Add PointCloud Name',
          callback: (pointCloudName) => {
            if (!pointCloudName) {
              document.getElementById('browsePointCloudFile').value = '';
              return;
            }
            this.isDeleting = false;
            this.isUploadingPointCloud = true;
            this.maxProgress = event.target.files.length;
            this.progress = 1;
            this.fileProgress = 0;

            var onProgress = (e) => {
              this.currentFile = {
                name: e.name,
                size: e.size,
              };
              this.fileProgress = ((e.loadedBytes / e.size) * 100).toFixed(2);
              log(`Progress: ${this.fileProgress}%`);

              if (e.loadedBytes == e.size) {
                this.currentFile = null;
                this.fileProgress = 0;
                this.progress++;
                if (this.progress == this.maxProgress) {
                  log('Uploading Done.');
                }
              }
            };

            const onComplete = (pointCloudModel) => {
              log(pointCloudModel);

              if (!pointCloudModel) {
                document.getElementById('browsePointCloudFile').value = '';
                this.isUploadingPointCloud = false;
                this.$dialog.notify.error('Point Cloud uploaded failed.', {
                  position: 'top-right',
                  timeout: 3000,
                });
                return;
              }

              if (!this.pointclouds) this.$emit('update_pointclouds', []);

              pointCloudModel.isUploaded = true;

              pointcloudsService.update(pointCloudModel).then(() => {
                updatePointClouds(pointCloudModel);
                document.getElementById('browsePointCloudFile').value = '';
                this.isUploadingPointCloud = false;
                this.$dialog.notify.success('Point Cloud uploaded successfully.', {
                  position: 'top-right',
                  timeout: 3000,
                });
              });
            };

            const updatePointClouds = (pointCloudModel) => {
              let index = this.pointclouds.findIndex((o) => o.id == pointCloudModel.id);
              if (index != -1) {
                let newPcs = [...this.pointclouds];
                newPcs[index] = pointCloudModel;
                this.$emit('update_pointclouds', newPcs);
              } else {
                this.$emit('update_pointclouds', this.pointclouds.concat(pointCloudModel));
              }
            };

            const onFileStartUpload = (file) => {
              this.currentFile = {
                name: file.name,
                size: file.size,
              };
            };

            this.abortController = new AbortController();

            this.forgeService.uploadPointCloud(
              event.target.files,
              pointCloudName,
              this.$route.params.id,
              this.abortController,
              onFileStartUpload,
              onProgress,
              onComplete,
              updatePointClouds,
            ).catch(() => {
              document.getElementById('browsePointCloudFile').value = '';
              this.isUploadingPointCloud = false;
              this.$dialog.notify.error('Point Cloud uploaded failed.', {
                position: 'top-right',
                timeout: 3000,
              });
            });
            
          },
          input: {
            inputName: 'Name',
            inputValue: '',
          },
        });
      },
      onPointCloudDeleting(pcModel) {
        if (this.isUploadingPointCloud) {
          this.$dialog.notify.warning('Cannot delete while uploading.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }

        this.$dialog.error({
          text: 'Are you sure you want to delete point cloud?',
          title: 'Delete Point Cloud',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {                                               
                this.deletePointClouds([pcModel.id]);
              },
            },
          },
        });
      },
      async deletePointClouds(ids) {
        this.isDeleting = true;
        return httpService
          .delete({
            url: `api/PointClouds/deletePointCloudFolder`,
            data: ids,
          })
          .then(() => {
            this.isDeleting = false;
            let newPcs = this.pointclouds.filter((o) => !ids.includes(o.id));
            this.$emit('update_pointclouds', newPcs);
            this.$dialog.notify.success('Point Cloud deleted successfully.', {
              position: 'top-right',
              timeout: 3000,
            });
          })
          .catch((error) => {
            log(error);
          });
      },
      async downloadPointCloudUtility() {
        try {
          // Get the latest version info
          const latestResponse = await pointCloudUtilityService.getLatest();
          const latestVersion = latestResponse.data;

          // Get a fresh download URL (SAS-signed, valid 1 hour)
          const downloadResponse = await pointCloudUtilityService.getDownloadUrl(latestVersion.id);
          const { downloadUrl } = downloadResponse.data;

          // Trigger the download
          downloadURI(downloadUrl, latestVersion.fileName || 'PointCloudUtility.exe');
        } catch (err) {
          const errorMessage = err?.response?.status === 404
            ? 'No Point Cloud Utility version available. Please contact support.'
            : err?.response?.data?.message || 'Failed to download Point Cloud Utility';

          this.$dialog.notify.error(errorMessage, {
            position: 'top-right',
            timeout: 5000,
          });
        }
      },
      clickOnUploadPointCloud() {
        if (this.isUploadDisabled) {
          let message = '';
          if (this.storageLimits.uploadLimit === 0) {
            message = 'Upload for this facility has been disabled. Please contact Envizion Management for more information.';
          } else if (this.isStorageLimitReached) {
            message = `Scans Upload limit reached (${this.storageLimits.uploadUsed}/${this.storageLimits.uploadLimit}). Please contact Envizion Management to increase your scans upload limit.`;
          }
          
          this.$dialog.notify.warning(message, {
            position: 'top-right',
            timeout: 5000,
          });
          return;
        }
        document.getElementById('browsePointCloudFile').click();
      },
      editPointCloudUrl(item) {
        this.$store.dispatch({
          type: 'prompt_Forge',
          title: 'Edit Point Cloud Name',
          callback: (name) => {
            if (!name || !name.trim()) return;
            item.name = name;

            //TODO: edit if url only
            if (item.isOnlyURL) {
              this.$store.dispatch({
                type: 'prompt_Forge',
                title: 'Edit Point Cloud URL',
                callback: (url) => {
                  if (!url || !url.trim()) return;
                  item.url = url;
                  postDataAsync('api/forge/pointClouds/editPointCloud', item);
                },
                input: {
                  inputName: 'URL',
                  inputValue: item.url,
                },
              });
            } else postDataAsync('api/forge/pointClouds/editPointCloud', item);
          },
          input: {
            inputName: 'Name',
            inputValue: item.name,
          },
        });
      },
      AddPointCloudURL() {
        this.$store.dispatch({
          type: 'prompt_Forge',
          title: 'Add Point Cloud File Url (cloud.js OR metadata.json)',
          callback: (url) => {
            if (!url || !url.trim()) return;

            this.$store.dispatch({
              type: 'prompt_Forge',
              title: 'Add Point Cloud Name',
              callback: (name) => {
                if (!name.trim()) return;
                this.forgeService.addPointCloudUrlToMongo(
                  this.$route.params.id,
                  name,
                  url,
                  (pointCloud) => {
                    if (!this.pointclouds) this.$emit('update_pointclouds', []);
                    pointCloud = Object.assign(new PointCloudModelInfo(), pointCloud);
                    this.$emit('update_pointclouds', this.pointclouds.concat(pointCloud));
                  },
                );
              },
              input: {
                inputName: 'Name',
                inputValue: '',
              },
            });
          },
          input: {
            inputName: 'Url',
            inputValue: '',
          },
        });
      },
      AddPointCloudFolder() {
        this.$store.dispatch({
          type: 'prompt_Forge',
          title: 'Add Synology folder of point clouds',
          callback: (url) => {
            if (!url || !url.trim()) return;
            if (!url.startsWith('/Reality/web')) {
              this.$dialog.notify.warning('Folder has to start with "/Reality/web".', {
                position: 'top-right',
                timeout: 3000,
              });
              return;
            }

            this.forgeService.addPointCloudFolder(this.$route.params.id, url, (pointClouds) => {
              if (!this.pointclouds) this.$emit('update_pointclouds', []);

              pointClouds = pointClouds.map((o) => Object.assign(new PointCloudModelInfo(), o));
              let existingPointClouds = this.pointclouds.map((o) => o.url);
              pointClouds = pointClouds.filter((o) => !existingPointClouds.includes(o.url));
              if (pointClouds.length == 0) {
                this.$dialog.notify.warning('No new point clouds found.', {
                  position: 'top-right',
                  timeout: 3000,
                });
                return;
              }

              this.$emit('update_pointclouds', this.pointclouds.concat(pointClouds));
              this.forgeService.sortByName(this.pointclouds);
            });
          },
          input: {
            inputName: 'Folder Url (/Reality/web)',
            inputValue: '',
          },
        });
      },
      toggleExpanded() {
        toggleExpandComponent(this);
      },
      cancelUpload() {
        this.abortController.abort('User cancelled the upload.');
        this.isUploadingPointCloud = false;
        this.$dialog.notify.warning('Uploading Point Clouds Cancelled.', {
          position: 'top-right',
          timeout: 3000,
        });
      },
    },
    computed: {
      
      ...mapGetters('ADMIN', {
        isPointCloudsDeleted: 'GET_IS_POINT_CLOUDS_DELETED',
      }),
      uploadProgress() {
        return Math.round((this.storageLimits.uploadUsed / this.storageLimits.uploadLimit) * 100);
      },
      forgeService() {
        return this.$store.state.forgeService;
      },
      isStorageLimitReached() {
        return this.storageLimits.uploadUsed >= this.storageLimits.uploadLimit && this.storageLimits.uploadLimit > 0;
      },
      isUploadDisabled() {
        return this.storageLimits.uploadLimit === 0 || this.isStorageLimitReached;
      },
      storageUsagePercentage() {
        if (!this.storageLimits.uploadLimit) return 0;
        return Math.min(100, Math.round((this.storageLimits.uploadUsed / this.storageLimits.uploadLimit) * 100));
      },
      storageStatusColor() {
        if (this.storageLimits.uploadLimit === 0) return 'error';
        if (this.storageUsagePercentage >= 90) return 'error';
        if (this.storageUsagePercentage >= 75) return 'warning';
        return 'success';
      },
      storageStatusIcon() {
        if (this.storageLimits.uploadLimit === 0) return 'mdi-block-helper';
        if (this.storageUsagePercentage >= 90) return 'mdi-alert-circle';
        if (this.storageUsagePercentage >= 75) return 'mdi-alert';
        return 'mdi-check-circle';
      },
      tooltipColor() {
        return this.storageLimits.uploadLimit === 0 ? 'error' : 'warning';
      },
      tooltipIconColor() {
        return 'white';
      },
      tooltipIcon() {
        return this.storageLimits.uploadLimit === 0 ? 'mdi-block-helper' : 'mdi-alert';
      },
      tooltipMessage() {
        if (this.storageLimits.uploadLimit === 0) {
          return 'Upload for this facility has been disabled. Please contact Envizion Management for more information.';
        } else if (this.isStorageLimitReached) {
          return `Storage limit reached (${this.storageLimits.uploadUsed}/${this.storageLimits.uploadLimit}). Please contact Envizion Management to increase your scans upload limit.`;
        }
        return '';
      },
    },
    watch: {
      isPointCloudsDeleted(newValue) {
        if (newValue == true) {
          this.$emit('isPointClouds_Deleted', newValue);
        }
      },
    },
  };
</script>

<style scoped>
  .point-cloud {
    background-size: cover;
    background-image: url(../../../images/pointCloud-black.png);
    width: 23px;
    height: 23px;
    margin-right: 10px;
  }

  .linked-pointcloud {
    font-size: 12px;
    text-decoration: underline;
    color: darkblue;
  }

  v-data-table {
    position: relative;
  }
  .v-data-table .v-data-footer {
    position: fixed;
    right: 0px;
    width: -webkit-fill-available;
  }
</style>
